import moment from "moment/moment";
import React from "react";
import { Badge, Card } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { useDispatch } from "react-redux";
import { eventsActions } from "../../../store/events/eventsSlice";
import { useEventsContext } from "../EventsContext/EventsContext";
import EventSearchToolbar from "./EventSearchToolbar";
import { useNavigate } from "react-router-dom";

const EventCard = ({ event }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  return (
    <Card key={event.eventId} border="primary" className="m-10">
      <Card.Header className="bg-theme">
        <div className="row justify-content-between">
          <div className="col-lg-10">
            <h4
              className="text-light text-bold"
              // onClick={() => {
              //   navigate(`/event/${event.eventId}`);
              // }}
            >
              {event.eventName}
            </h4>
          </div>
          <div className="col-lg-2">
            <h4>
              <Badge className="bg-success text-bold text-light" pill>
                Status: {event.eventStatusName.toUpperCase()}
              </Badge>
            </h4>
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="row">
          <div className="col-lg-6 justify-content-start">
            <b>Location:</b>
            {" " + event.address + ", " + event.state + ", " + event.zip}
          </div>
          <div className="col-lg-6 justify-content-end">
            <b>Date:</b>
            {moment(event.startDate, "YYYY-MM-DD").format("MMM DD YYYY") ===
            moment(event.endDate, "YYYY-MM-DD").format("MMM DD YYYY")
              ? " " +
                moment(event.startDate, "YYYY-MM-DD").format("MMM DD YYYY")
              : " " +
                moment(event.startDate, "YYYY-MM-DD").format("MMM DD YYYY") +
                " - " +
                moment(event.endDate, "YYYY-MM-DD").format("MMM DD YYYY")}
          </div>
          <div className="row">
            {event.streams.map((s, i) => {
              let fees = [];
              s.age_categories.forEach((current) => {
                current.times.forEach((c) => {
                  if (fees.length === 0) {
                    fees.push(c.fee);
                    fees.push(c.fee);
                  }
                  if (c.fee < fees[0]) {
                    fees[0] = c.fee;
                  }
                  if (c.fee > fees[1]) {
                    fees[1] = c.fee;
                  }
                });
              });
              return (
                <div key={i} className="col-lg-4">
                  <p>
                    <b>{s.streamName.toUpperCase()}</b>
                    <br />
                    <small className="text-secondary">
                      Event Fee:{" "}
                      {fees[0] === fees[1]
                        ? `$${fees[0]}`
                        : `$${fees[0]}-$${fees[1]}`}
                    </small>
                    <br />
                    <small className="text-secondary">
                      Age Groups:{" "}
                      {s.age_categories
                        .reduce((combined, current) => {
                          let initials = [];
                          current.ageCategoryName.split(" ").forEach((word) => {
                            initials.push(word[0]);
                          });
                          combined.push(initials.join("").toUpperCase());
                          return combined;
                        }, [])
                        .join(", ")}
                    </small>
                  </p>
                </div>
              );
            })}
          </div>
          <div className="row justify-content-end">
            <div className="col-12">
              <button
                className="btn btn-transparent"
                onClick={() => {
                  navigate(`/event/${event.eventId}`);
                }}
              >
                Details
              </button> 
              {event.eventStatusId === 1 &&
              moment(event.registrationStartDate).isSameOrBefore(new Date()) &&
              moment(event.registrationEndDate).isAfter(new Date()) ? (
                <button
                  className="btn btn-secondary text-light"
                  onClick={() => {
                    dispatch(eventsActions.setEvent(event));
                  }}
                >
                  Register
                </button>
              ) : moment(event.registrationEndDate).isBefore(new Date()) ? (
                <button
                  className="btn btn-theme-muted text-light"
                  disabled={true}
                >
                  Registration Closed
                </button>
              ) : (
                <button
                  className="btn btn-theme-muted text-light"
                  disabled={true}
                >
                  Coming Soon
                </button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

const TablePagination = () => {
  const {
    eventIndex,
    setEventIndex,
    eventPageNumber,
    setEventPageNumber,
    eventsPerPage,
    displayEvents,
  } = useEventsContext();
  let pageCount = Math.ceil(displayEvents.length / eventsPerPage);

  const onPageClick = (e) => {
    if (e.target.text === undefined) {
      return;
    }
    let pageNum = 1;
    let index = 0;

    if (e.target.text === "«First") {
      pageNum = 1;
      index = 0;
    } else if (e.target.text === "»Last") {
      pageNum = pageCount;
      if (displayEvents.length % eventsPerPage === 0) {
        index = displayEvents.length - eventsPerPage;
      } else {
        index = displayEvents.length - (displayEvents.length % eventsPerPage);
      }
    } else if (e.target.text === "›Next") {
      pageNum = eventPageNumber + 1;
      index = eventIndex + eventsPerPage;
    } else if (e.target.text === "‹Previous") {
      pageNum = eventPageNumber - 1;
      index = eventIndex - eventsPerPage;
    } else {
      let pageRequested = parseInt(e.target.text);
      pageNum = pageRequested;
      if (pageNum === pageCount) {
        if (displayEvents.length % eventsPerPage === 0) {
          index = displayEvents.length - eventsPerPage;
        } else {
          index = displayEvents.length - (displayEvents.length % eventsPerPage);
        }
      } else if (pageNum === 1) {
        index = 0;
      } else {
        index = eventsPerPage * pageRequested;
      }
    }

    setEventPageNumber(pageNum);
    setEventIndex(index);
  };
  return (
    <div className="d-flex justify-content-center mb-20">
      <Pagination>
        <Pagination.First onClick={onPageClick} />
        <Pagination.Prev onClick={onPageClick} />
        {[...Array(pageCount)].map((e, i) => {
          return (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === eventPageNumber}
              activeLabel=""
              onClick={onPageClick}
            >
              {i + 1}
            </Pagination.Item>
          );
        })}
        <Pagination.Next onClick={onPageClick} />
        <Pagination.Last onClick={onPageClick} />
      </Pagination>
    </div>
  );
};

const EventTable = () => {
  const { eventIndex, eventsPerPage, displayEvents } = useEventsContext();
  return (
    <>
      {displayEvents &&
        displayEvents.slice(eventIndex, eventIndex + eventsPerPage).map((e) => {
          return <EventCard key={e.eventId} event={e} />;
        })}
      <TablePagination />
    </>
  );
};

const EventsList = () => {
  return (
    <>
      <div className="col-xs-12 col-md-8 bg-light">
        <EventSearchToolbar />
        <EventTable />
      </div>
    </>
  );
};

export default EventsList;
